import ko from "knockout";

ko.bindingHandlers.tabbable = {
    update: function (element, valueAccessor) {
        const isTabbable = ko.unwrap(valueAccessor());
        element.tabIndex = isTabbable ? 0 : -1;
    },
};
